<div
  class="button-menu__container"
  [class.button-menu__container-resident]="btnResident || btnVendor"
  [class.button-menu__container-search]="btnSearch"
  [class]="['button-menu__container--' + size]">
  <ng-container *ngIf="!isDisabled; else strokeButtonTemplate">
    <ng-container *ngIf="isRaisedButton; else isStrokedButton">
      <button
        mat-raised-button
        color="primary"
        class="button-menu"
        [disabled]="mainButtonDisabled"
        [class.button-menu--with-actions]="!!options"
        [class.button-menu--disabled]="isDisabled"
        [ngStyle]="{ 'width.px': btnWidth }"
        (click)="onAction(mainButtonAction)">
        <div class="button-menu__label">
          <mat-spinner *ngIf="isInProgress" color="accent" diameter="20"></mat-spinner>
          <ng-container *ngIf="titlePrefix">{{ titlePrefix + '' }}</ng-container>
          {{ isLowercase ? (title | lowercase) : title }}
        </div>
      </button>
    </ng-container>
    <ng-template #isStrokedButton>
      <button
        mat-stroked-button
        color="primary"
        class="button-menu"
        [disabled]="mainButtonDisabled"
        [class.button-menu--with-actions]="!!options"
        [class.button-menu--disabled]="isDisabled"
        [class.reports]="btnReports"
        [class.mobile-button]="btnResident || btnSearch || btnVendor"
        [class.mobile-button-search]="btnSearch"
        [ngClass]="[
          btnResident || btnSearch || btnVendor ? 'mobile-button' : '',
          btnVendor ? 'mobile-button-vendor btn-vendor-span' : ''
        ]"
        [ngStyle]="{ 'width.px': btnWidth - 2, 'margin-right': btnSearch ? '0' : '1px' }"
        (click)="onAction(mainButtonAction)">
        <div class="button-menu__label" *ngIf="!btnVendor">
          <mat-spinner *ngIf="isInProgress" color="accent" diameter="20"></mat-spinner>
          <ng-container *ngIf="titlePrefix">{{ titlePrefix + '' }}</ng-container>
          {{ isLowercase ? (title | lowercase) : title }}
          <app-icon
            *ngIf="btnSearch"
            [iconColor]="EColorPalette.cGray7"
            [iconHeight]="18"
            [iconWidth]="18"
            [svg]="EIcon.ICON_SEARCH"></app-icon>
        </div>

        <div class="display-flex justify-content-space-between" *ngIf="btnVendor">
          <mat-spinner *ngIf="isInProgress" color="accent" diameter="20"></mat-spinner>
          <div *ngIf="!isInProgress && titlePrefix">{{ titlePrefix + ' ' }}</div>
          <div>{{ isLowercase ? (title | lowercase) : title }}</div>
        </div>
      </button>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="!isDisabled; else strokeMenuButtonTemplate">
    <button
      *ngIf="options"
      mat-stroked-button
      class="button-menu__options drop-down-button"
      [class.drop-down-button--stroke]="!isRaisedButton"
      [class.drop-down-button--disabled]="mainButtonDisabled"
      [class.reports]="btnReports"
      [class.resident-button-options]="btnResident || btnSearch || btnVendor"
      [class.resident-button-options-search]="btnSearch"
      [disabled]="arrowDropdownDisabled"
      [matMenuTriggerFor]="dropdownMenu"
      (menuOpened)="isMenuOpen = true"
      (menuClosed)="isMenuOpen = false"
      #menuTrigger="matMenuTrigger">
      <app-icon
        *ngIf="!btnResident && !btnVendor && !btnSearch"
        [iconColor]="(btnReports && hasUnsavedChanges) || isRaisedButton ? EColorPalette.cWhite : EColorPalette.cGreen3"
        [iconHeight]="16"
        [iconWidth]="16"
        [svg]="isMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></app-icon>
      <app-icon
        *ngIf="btnResident || btnVendor || btnSearch"
        [iconColor]="btnSearch ? EColorPalette.cGray7 : EColorPalette.cWhite"
        [iconHeight]="12"
        [iconWidth]="12"
        [svg]="
          btnSearch ? (isMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN) : isMenuOpen ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN
        "></app-icon>
    </button>
  </ng-container>
</div>

<mat-menu #dropdownMenu="matMenu" [xPosition]="xPosition" class="menu-with-backdrop">
  <button
    *ngFor="let option of optionsToDisplay"
    mat-menu-item
    [disabled]="option.disabled"
    [matTooltip]="option.tooltip"
    (click)="onAction(option.id, true)">
    {{ option.label }}
  </button>
</mat-menu>

<ng-template #strokeButtonTemplate>
  <button
    mat-stroked-button
    color="primary"
    class="button-menu"
    [class.button-menu--with-actions]="!!options"
    [class.button-menu--disabled]="isDisabled"
    (click)="onAction(mainButtonAction)">
    <div class="button-menu__label">
      <mat-spinner *ngIf="isInProgress" color="accent" diameter="20"></mat-spinner>
      {{ title }}
    </div>
  </button>
</ng-template>

<ng-template #strokeMenuButtonTemplate>
  <button
    *ngIf="options"
    class="button-menu__options drop-down-button"
    [class.drop-down-button--stroke]="isDisabledStroke"
    mat-stroked-button
    [matMenuTriggerFor]="dropdownMenu"
    (menuOpened)="isMenuOpen = true"
    (menuClosed)="isMenuOpen = false">
    <app-icon
      [iconColor]="isDisabledStroke ? EColorPalette.cGreen3 : EColorPalette.cWhite"
      [iconHeight]="16"
      [iconWidth]="16"
      [svg]="isMenuOpen ? EIcon.CARET_UP : EIcon.CARET_DOWN"></app-icon>
  </button>
</ng-template>
